import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/** QR encodes member id (globally unique); customer number is shown for manual entry at POS. */
export function LoyaltyMemberQr({
  memberId,
  memberCode,
  size = 200,
  cafeName,
}: {
  memberId: string;
  memberCode: string;
  size?: number;
  cafeName?: string;
}) {
  const [dataUrl, setDataUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void QRCode.toDataURL(memberId, {
      width: size,
      margin: 2,
      errorCorrectionLevel: 'M',
    })
      .then((url) => {
        if (!cancelled) setDataUrl(url);
      })
      .catch(() => {
        if (!cancelled) setDataUrl(null);
      });
    return () => {
      cancelled = true;
    };
  }, [memberId, size]);

  return (
    <div className="loyalty-member-qr">
      {dataUrl ? (
        <img src={dataUrl} alt={`Customer number ${memberCode}`} width={size} height={size} />
      ) : (
        <div
          className="loyalty-member-qr-placeholder"
          style={{ width: size, height: size }}
          aria-hidden
        />
      )}
      <p className="loyalty-member-qr-code">{memberCode}</p>
      {cafeName && <p className="loyalty-member-qr-cafe muted">{cafeName}</p>}
    </div>
  );
}
